import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/components/ui/select';
import { getNewStatusHumanizedName } from '@/utils/get-new-status-humanized-name';
import { Loader2Icon, X } from 'lucide-react';
import React, { useState } from 'react';
import {
	NewStatus,
	StatusChangeReason,
} from '../../../use-cases/update-certificate';
import styles from './confirm-process.module.scss';

type ConfirmProcessProps = {
	newStatus: NewStatus;
	certificateName: string;
	isUpdating: boolean;
	onConfirm: (reason: StatusChangeReason) => void;
	onReject: () => void;
};
const ConfirmProcess: React.FC<ConfirmProcessProps> = (
	props: ConfirmProcessProps,
) => {
	const [changeStatusReason, setChangeStatusReason] =
		useState<StatusChangeReason>(
			props.newStatus === 'suspended'
				? 'certificateHold'
				: props.newStatus === 'reactivated'
					? 'removeFromCRL'
					: 'unspecified',
		);
	const newStatusName = getNewStatusHumanizedName(props.newStatus);

	return (
		<div className={styles['confirm-process']}>
			<div className={styles['title']}>
				<span>{newStatusName} firma</span>
				<Button variant="ghost" size="sm" onClick={props.onReject}>
					<X />
				</Button>
			</div>
			{props.newStatus === 'revoked' && (
				<>
					<Label>Slecciona la razón de revocación</Label>
					<Select
						value={changeStatusReason}
						onValueChange={(newValue) =>
							setChangeStatusReason(
								newValue as StatusChangeReason,
							)
						}
					>
						<SelectTrigger placeholder="...">
							<SelectValue></SelectValue>
						</SelectTrigger>
						<SelectContent>
							<SelectItem value="unspecified">
								No especificado
							</SelectItem>
							<SelectItem value="keyCompromise">
								Llave comprometida
							</SelectItem>
							<SelectItem value="affiliationChanged">
								Cambio afiliacion
							</SelectItem>
						</SelectContent>
					</Select>
				</>
			)}
			<span className={styles['confirmation-text']}>
				¿Estás seguro de {newStatusName} la firma{' '}
				<span className={styles['certificate-name']}>
					{props.certificateName}
				</span>
				?
				<br />
				<div className={styles.disclaimer}>
					No podrás recuperarla después
				</div>
			</span>
			<div className={styles['actions']}>
				<Button
					onClick={props.onReject}
					variant="outline"
					disabled={props.isUpdating}
				>
					No
				</Button>
				<Button
					onClick={() => props.onConfirm(changeStatusReason)}
					disabled={props.isUpdating}
					variant={
						props.newStatus === 'revoked'
							? 'destructive'
							: 'default'
					}
				>
					Sí
					{props.isUpdating && (
						<Loader2Icon className="animate-spin" />
					)}
				</Button>
			</div>
		</div>
	);
};

export default ConfirmProcess;
